import TabPanel from './tab-panel.element.js';

export default TabPanel;

TabPanel.define('wje-tab-panel', TabPanel);
